<template>
    <div
      style=""
      :class="{
        selected: isSelected
      }"
      class="px-2 py-1 select-seat d-flex justify-content-between"
      @click="$emit('select')"
      >
      <div>
        <b-icon icon="person-plus-fill" class="mr-2" />
        <strong> <translate>Room</translate> {{ roomIndex + 1 }} - <translate>Pax</translate> {{ paxIndex + 1 }}</strong>
      </div>
      <template v-if="showPaxName">
        <b-badge variant="success" style="line-height: 1.5;">{{ pax.fname }} {{ pax.lname}}</b-badge>
      </template>
      <template v-if="showSelectedSlot">
        <b-badge variant="success" style="line-height: 1.5;">{{ selectedSlot.label }}</b-badge>
      </template>
    </div>
</template>

<script>
export default {
  props: {
    pax: {
      type: Object,
      required: true
    },
    roomIndex: {
      type: Number,
      required: true
    },
    paxIndex: {
      type: Number,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    selectedSlot: {
      type: Object,
      default: null
    }
  },
  computed: {
    showPaxName () {
      return this.pax.fname || this.pax.lname
    },
    showSelectedSlot () {
      return this.selectedSlot
    }
  }
}
</script>

<style>
.isSelected {
  background-color: #f0f0f0;
  /* rounded lighgray border */
  border: 1px solid #d0d0d0;
  border-radius: 5px;
}
.select-seat{
  border-radius:.25rem;
  cursor: pointer;
  border:1px solid #1a8fe3;
  margin-bottom:3px;
}
</style>
